// Preview deployments also run with NODE_ENV=production; the IDs are simply unset there.
export const TRACKING_ENABLED = process.env.NODE_ENV === "production";
